export const TICKET_LIMIT_PER_REQUEST = 2500
export const NUM_ROUNDS_TO_CHECK_FOR_REWARDS = 3
export const NUM_ROUNDS_TO_FETCH_FROM_NODES = 3

// 2026-10-01 (Bez): the lottery is parked. LOTTERY_ARCHIVED=1 (build-time env, passed through next.config.mjs `env`)
// hides it from the menu and the home page and turns /lottery into a notice + the claim flow for the finished rounds.
// Every component, route and the /api/subgraph/lottery proxy stay in place; unset the flag and it returns unchanged.
// docs/PARKED-PRODUCTS-20261001.md records the kept decisions.
export const LOTTERY_ARCHIVED = process.env.LOTTERY_ARCHIVED === '1'
export const LOTTERY_LAST_ROUND = 116
export const LOTTERY_CONTRACT_BSCSCAN = 'https://bscscan.com/address/0xec1ED03Da04D6ab50bF51A5C56F9e340c894D931'
